import AlphabetIcon from './component.jsx'
export default AlphabetIcon
